/**
 * `NotFoundError` is an error thrown when resource doesn't exist
 */
export class NotFoundError extends Error {
  isNotFoundError = true

  constructor(message: string) {
    super(message)
    this.name = 'NotFoundError'
  }
}
